import React, { useState } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useDispatch } from "react-redux";
import { alertActions } from "_store";
import { postBaseAndHeatFactorFilterApi } from "services/baseAndHeatFactor/baseAndHeatFactor.thunks";
import BaseAndHeatFactorReportFilter from "./BaseAndHeatFactorReportFilter";
import BaseAndHeatFactorReportDownload from "./BaseAndHeatFactorReportDownload";
import BaseAndHeatFactorsReportList from "./BaseAndHeatFactorsReportList";
import BaseAndHeatFactorReportDetails from "./BaseAndHeatFactorReportDetails";

const BaseAndHeatFactorsReport = () => {
  const header = "Base and Heat Factors Report";
  const dispatch = useDispatch();

  const [accountNumber, setAccountNumber] = useState("");
  const [filteredData, setFilteredData] = useState(null); // null = no filter active

  const handleSearchSubmit = async (accountNumbers) => {
    dispatch(alertActions.clear());
    try {
      const res = await dispatch(postBaseAndHeatFactorFilterApi(accountNumbers)).unwrap();

      // Case 1: Succeeded: false — no results found
      if (!res?.Succeeded && res?.Message) {
        dispatch(alertActions.error({ message: res.Message, header }));
        setFilteredData([]);
        setAccountNumber("");
        return;
      }

      // Case 2: Succeeded: true but Data.Message has invalid account warnings
      if (res?.Data?.Message) {
        dispatch(alertActions.error({ message: res.Data.Message, header }));
      }

      setFilteredData(res?.Data?.reportData ?? []);
      setAccountNumber("");
    } catch (error) {
      setAccountNumber("");
      dispatch(alertActions.error({ message: error.message || error, header }));
    }
  };

  const handleClear = () => {
    setFilteredData(null);
    dispatch(alertActions.clear());
  };

  return (
    <>
      <Typography component="div" className="userprofilelist">
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Grid container>
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <Typography variant="h2" className="userprofilelistcontent">
                  Reports <span>{header}</span>{" "}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 8 }}>
                <Grid
                  container
                  spacing={2}
                  justifyContent="flex-end"
                  className="MarketerManagement"
                >
                  <Grid size={{ xs: 12, sm: 12, md: 8 }}>
                    <Grid container spacing={2} justifyContent="flex-end">
                      <Grid size={{ xs: 6, sm: 6, md: 5 }}>
                        <BaseAndHeatFactorReportFilter
                          header={header}
                          accountNumber={accountNumber}
                          setAccountNumber={setAccountNumber}
                          onSearchSubmit={handleSearchSubmit}
                          onClear={handleClear}
                        />
                      </Grid>
                      <Grid size={{ xs: 6, sm: 6, md: 5 }}>
                        <BaseAndHeatFactorReportDownload data={Array.isArray(filteredData) ? filteredData : []} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Typography>

      <BaseAndHeatFactorReportDetails />

      <Grid container direction="row" spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <div className="MarketerListMaterialReactTable">
            <BaseAndHeatFactorsReportList data={Array.isArray(filteredData) ? filteredData : []} />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default BaseAndHeatFactorsReport;
